/*
  Nalia routine bundles.
  One place for the "add a step / remove a step" cart logic, used by the
  routine section on product pages and by the cart drawer.

  add(key, pageKeys): puts the cheapest mix of bundles and singles for the
  whole routine in the cart, including the page's own product when it is not
  in the cart yet. A bundle already in the cart stays, or is replaced by a
  bigger bundle that contains it.
  remove(key, pageKeys): takes out just that step and puts the rest back the
  cheapest way (e.g. 4 Steps minus Serum = The Triple Threat).

  Lines on a subscription, gift lines (free, or with _ properties) and lines
  with a quantity above one are never removed or replaced.
  Config comes from snippets/nalia-bundle-config.liquid (window.NaliaBundleConfig).
*/
(function () {
  // Cart drawer guard. When the cart was empty at page load, the first add
  // re-renders the drawer while it is opening and it ends up open but not
  // modal: just the "Cart" header bar, no items or checkout button (seen on
  // the live theme too, phone and desktop). Reopening it as a modal fixes it.
  if (!window.__naliaDrawerGuard) {
    window.__naliaDrawerGuard = true;
    var fixDrawer = function () {
      var d = document.querySelector('.cart-drawer__dialog');
      if (d && d.open && !d.matches(':modal')) {
        try { d.close(); d.showModal(); } catch (e) {}
      }
    };
    document.addEventListener('cart:update', function () {
      setTimeout(fixDrawer, 300);
      setTimeout(fixDrawer, 1000);
      setTimeout(fixDrawer, 2000);
    });
  }

  // Routine adds never open the cart drawer. When an add completes the kit,
  // the free gift app puts the Dewy Duo in and then opens the drawer itself
  // (it calls the drawer's open() directly and sends its cart update without
  // the theme's "don't open" flag). For 10 seconds after she taps Add or
  // Remove in the routine, both are kept quiet. Any other tap ends that window
  // at once, so the cart icon, the product page's Add to cart button and
  // edits inside the drawer open it as before.
  if (!window.__naliaQuietGift) {
    window.__naliaQuietGift = true;
    var quietUntil = 0;
    var isQuiet = function () { return Date.now() < quietUntil; };
    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var t = e.target;
      quietUntil = (t && t.closest && t.closest('.nr [data-nr-add], .nr [data-nr-rm]')) ? Date.now() + 10000 : 0;
    }, true);
    window.addEventListener('cart:update', function (e) {
      var d = e.detail, src = (d && (d.sourceId || (d.data && d.data.source))) || '';
      if (src === 'bogos' && isQuiet() && d) {
        if (d.data) d.data.deferDrawerOpen = true; else d.data = { source: 'bogos', deferDrawerOpen: true };
      }
    }, true);
    if (window.customElements) {
      customElements.whenDefined('cart-drawer-component').then(function () {
        var C = customElements.get('cart-drawer-component');
        if (!C || !C.prototype || typeof C.prototype.open !== 'function' || C.prototype.__naliaQuiet) return;
        var open = C.prototype.open;
        C.prototype.open = function () { if (isQuiet()) return; return open.apply(this, arguments); };
        C.prototype.__naliaQuiet = true;
      });
    }
  }

  // Keep the cart drawer open while she edits it. Changing a line (×, +/-,
  // remove) makes the theme and the gift app re-render the header, which
  // replaces the open drawer with a closed one. For a few seconds after one
  // of those taps, a closed drawer is reopened straight away. Any other tap
  // (close button, backdrop, checkout) or Escape ends that window at once.
  if (!window.__naliaHoldDrawer) {
    var holdUntil = 0, holdWatch = null;
    var reopenDrawer = function () {
      if (Date.now() > holdUntil) return;
      var c = document.querySelector('cart-drawer-component');
      var d = document.querySelector('.cart-drawer__dialog');
      if (!c || !d) return;
      if (!d.open) {
        try { d.showModal(); } catch (e) {}
        if (!d.open && typeof c.open === 'function') { try { c.open(); } catch (e) {} }
      } else if (!d.matches(':modal')) {
        try { d.close(); d.showModal(); } catch (e) {}
      }
    };
    var holdDrawer = function (ms) {
      holdUntil = Date.now() + (ms || 6000);
      if (holdWatch) return;
      holdWatch = new MutationObserver(reopenDrawer);
      holdWatch.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
      var stop = function () {
        if (Date.now() < holdUntil) { setTimeout(stop, 500); return; }
        holdWatch.disconnect(); holdWatch = null;
      };
      setTimeout(stop, 500);
    };
    window.__naliaHoldDrawer = holdDrawer;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var edit = t.closest('.cart-drawer__dialog') && t.closest('[data-nalia-rm], .quantity-minus, .quantity-plus, .cart-items__remove');
      if (edit) holdDrawer(6000); else holdUntil = 0;
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') holdUntil = 0; }, true);
  }

  // Cart: how often, per line (snippets/nalia-cart-plan.liquid). Tapping
  // One-time / 30 days / 60 days moves that line onto the chosen plan, or off
  // any plan, and refreshes the drawer. Works on every page: this file is
  // also loaded site-wide from snippets/nalia-brand-styles.liquid.
  if (!window.__naliaPlan) {
    window.__naliaPlan = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nalia-plan]');
      if (!b) return;
      var g = b.closest('[data-nalia-plan-group]');
      if (!g) return;
      e.preventDefault();
      e.stopPropagation();
      if (b.getAttribute('aria-pressed') === 'true' || g.classList.contains('is-busy')) return;
      var was = g.querySelector('[aria-pressed="true"]');
      g.classList.add('is-busy');
      g.querySelectorAll('[data-nalia-plan]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(8000);
      // Show the result straight away; Shopify confirms in the background and
      // the drawer redraw that follows replaces these estimates with its own.
      try { planPreview(g, was, b); } catch (err) {}
      var plan = b.getAttribute('data-nalia-plan');
      var body = { id: g.getAttribute('data-key'), quantity: parseInt(g.getAttribute('data-qty'), 10) || 1, selling_plan: plan ? parseInt(plan, 10) : null };
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (c) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: c, sourceId: 'nalia-plan', data: { source: 'nalia-plan', itemCount: c.item_count, deferDrawerOpen: true } }
          }));
          if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(5000);
        })
        .catch(function () {
          g.classList.remove('is-busy');
          g.querySelectorAll('[data-nalia-plan]').forEach(function (x) { x.setAttribute('aria-pressed', x === was ? 'true' : 'false'); });
          // put the drawer back to what the cart really holds
          fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: 'nalia-plan', data: { source: 'nalia-plan', itemCount: c.item_count, deferDrawerOpen: true } } }));
          });
        });
    }, true);

    // Instant preview of a plan change, from the prices printed on the buttons
    // (snippets/nalia-cart-plan.liquid): the line price and its crossed-out
    // one-time price, the note beside the quantity, the cart total and the
    // "You save" line in the box.
    var moneyLike = function (text, cents) {
      var n = (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return text.replace(/[\d,]+(\.\d{2})?/, n);
    };
    var planPreview = function (g, oldBtn, newBtn) {
      var oldP = parseInt(oldBtn && oldBtn.getAttribute('data-line-price'), 10);
      var newP = parseInt(newBtn.getAttribute('data-line-price'), 10);
      var oneP = parseInt(g.querySelector('[data-nalia-plan=""]').getAttribute('data-line-price'), 10);
      if (isNaN(oldP) || isNaN(newP) || isNaN(oneP)) return;
      var row = document.querySelector('.cart-items__table-row[data-key="' + g.getAttribute('data-key') + '"]');
      if (row) {
        var cell = row.querySelector('.cart-items__price');
        var main = cell && cell.querySelector('text-component .money, text-component');
        if (main) main.textContent = moneyLike(main.textContent, newP);
        var s = cell && cell.querySelector('s.compare-at-price');
        if (newP < oneP) {
          if (!s && cell) { s = document.createElement('s'); s.className = 'compare-at-price'; s.textContent = moneyLike(main ? main.textContent : '$0.00', oneP); cell.appendChild(s); }
          else if (s) s.textContent = moneyLike(s.textContent, oneP);
        } else if (s) { s.remove(); }
        var qty = row.querySelector('.cart-items__quantity');
        var note = qty && qty.querySelector('.nalia-plan-note');
        var noteText = newBtn.getAttribute('data-note');
        if (noteText && qty) { if (!note) { note = document.createElement('p'); note.className = 'nalia-plan-note'; qty.appendChild(note); } note.textContent = noteText; }
        else if (note) { note.remove(); }
      }
      document.querySelectorAll('.cart-drawer .cart__total .money, .cart__total-value .money').forEach(function (t) {
        var cur = parseInt(t.textContent.replace(/[^\d]/g, ''), 10);
        if (!isNaN(cur)) t.textContent = moneyLike(t.textContent, cur + (newP - oldP));
      });
      var saved = 0;
      document.querySelectorAll('[data-nalia-plan-group]').forEach(function (grp) {
        var one = parseInt(grp.querySelector('[data-nalia-plan=""]').getAttribute('data-line-price'), 10);
        var on = grp.querySelector('[aria-pressed="true"]');
        var p = parseInt(on && on.getAttribute('data-line-price'), 10);
        if (!isNaN(one) && !isNaN(p)) saved += one - p;
      });
      var perk = document.querySelector('.nalia-cart-sub__perk');
      if (perk) {
        perk.classList.toggle('nalia-cart-sub__perk--saved', saved > 0);
        perk.textContent = saved > 0 ? 'You save ' + moneyLike('$0.00', saved) + ' by subscribing' : 'On singles and the Dewy Duo. Skip or cancel any time.';
      }
    };
  }

  if (window.NaliaBundles) return;
  var C = window.NaliaBundleConfig;
  if (!C) return;

  var KEYS = ['cleanser', 'toner', 'serum', 'moisturiser', 'dewy'];
  var bundles = (C.bundles || []).filter(function (b) { return b && b.ok; });
  var byPid = {};
  KEYS.forEach(function (k) {
    var x = C.singles[k];
    if (x) byPid[x.p] = { keys: [k], v: x.v };
  });
  bundles.forEach(function (b) { byPid[b.p] = { keys: b.keys.concat(b.extra || []), v: b.v, bundle: b }; });

  var cart = null, cartAt = 0;
  var HKEY = 'naliaRoutinePulled';
  // The cart is kept in memory: every cart:update that carries the whole
  // cart refreshes it, so an Add can plan straight away instead of asking
  // Shopify first. Older than a minute, or missing, it is read again.
  function isCart(c) { return !!(c && c.items && c.token); }
  document.addEventListener('cart:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (isCart(r)) { cart = r; cartAt = Date.now(); }
  });
  function fresh() { return cart && Date.now() - cartAt < 60000 ? Promise.resolve(cart) : read(); }

  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function has(a, x) { return a.indexOf(x) > -1; }
  function pulled() { try { return JSON.parse(sessionStorage.getItem(HKEY) || '{}'); } catch (e) { return {}; } }
  function savePulled(o) { try { sessionStorage.setItem(HKEY, JSON.stringify(o)); } catch (e) {} }

  function analyse(pageKeys) {
    var owned = (pageKeys || []).slice(), units = [], locked = [];
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      var m = byPid[it.product_id];
      if (!m) return;
      owned = owned.concat(m.keys);
      var props = it.properties || {};
      var gift = it.final_line_price === 0 || Object.keys(props).some(function (p) { return p.charAt(0) === '_'; });
      var sub = !!it.selling_plan_allocation;
      if (gift || sub || it.quantity > 1) { locked = locked.concat(m.keys); return; }
      // A bundle's free extra (the kit's Dewy Duo) counts as owned, but is not
      // something she paid for, so it is never rebuilt as a paid line.
      units.push({ keys: m.bundle ? m.bundle.keys.slice() : m.keys, v: it.variant_id, line: it.key, bundle: m.bundle || null });
    });
    var cartKeys = [];
    units.forEach(function (u) { cartKeys = cartKeys.concat(u.keys); });
    return { owned: uniq(owned), units: units, locked: uniq(locked), cartKeys: uniq(cartKeys) };
  }

  // Cheapest exact mix of bundles and singles covering every key in T.
  function cover(T, keep) {
    keep = keep || [];
    var best = null, n = bundles.length;
    for (var mask = 0; mask < (1 << n); mask++) {
      var used = [], items = [], cost = 0, ok = true;
      for (var i = 0; i < n && ok; i++) {
        if (!(mask & (1 << i))) continue;
        var b = bundles[i];
        if (!b.keys.every(function (k) { return has(T, k); })) { ok = false; break; }
        var all = b.keys.concat(b.extra || []);
        if (all.some(function (k) { return has(used, k); })) { ok = false; break; }
        used = used.concat(all); cost += b.price; items.push({ v: b.v, b: b });
      }
      if (ok) {
        var chosen = items.map(function (it) { return it.b; });
        ok = keep.every(function (kb) {
          return chosen.some(function (b) { return b.id === kb.id || kb.keys.every(function (k) { return has(b.keys, k); }); });
        });
      }
      if (!ok) continue;
      T.forEach(function (k) {
        if (!ok || has(used, k)) return;
        var x = C.singles[k];
        if (!x || !x.ok) { ok = false; return; }
        cost += x.price; items.push({ v: x.v, k: k });
      });
      if (!ok) continue;
      if (!best || cost < best.cost || (cost === best.cost && items.length < best.items.length)) best = { cost: cost, items: items };
    }
    return best;
  }

  function diff(a, pick) {
    var target = pick.items.map(function (it) { return it.v; });
    var remove = [], toAdd = target.slice();
    a.units.forEach(function (u) {
      var i = toAdd.indexOf(u.v);
      if (i > -1) toAdd.splice(i, 1); else remove.push(u.line);
    });
    return { add: toAdd, remove: remove };
  }

  function planAdd(key, pageKeys) {
    pageKeys = pageKeys || [];
    var a = analyse(pageKeys);
    var free = function (k) { return !has(a.locked, k); };
    var T1 = uniq(a.cartKeys.concat([key])).filter(free);
    var pageExtra = pageKeys.filter(function (k) { return !has(a.cartKeys, k) && free(k); });
    var T2 = uniq(T1.concat(pageExtra));
    var keep = a.units.filter(function (u) { return u.bundle; }).map(function (u) { return u.bundle; });
    // The product on this page goes in with whatever she adds, if it is not in
    // the cart already: on the Toner page, Add on Cleanser puts in Toner and
    // Cleanser. The cheapest mix still applies, so it becomes a bundle where
    // one fits. If the page's product cannot be sold, only the tapped step goes in.
    var c1 = cover(T1, keep), c2 = pageExtra.length ? cover(T2, keep) : null, pick = c1, pulledIn = [];
    if (c2) { pick = c2; pulledIn = pageExtra; }
    if (!pick) return null;
    var d = diff(a, pick);
    var bundle = null;
    pick.items.forEach(function (it) { if (it.b && has(it.b.keys.concat(it.b.extra || []), key)) bundle = it.b; });
    d.bundle = bundle; d.pulledIn = pulledIn;
    return d;
  }

  // Can this step be taken out again? Only steps that are in the cart as
  // removable lines and are not the product the page is selling.
  function canRemove(key, pageKeys) {
    var a = analyse(pageKeys);
    if (has(pageKeys || [], key) || !has(a.cartKeys, key)) return false;
    var p = planRemove(key, pageKeys);
    return !!(p && (p.add.length || p.remove.length));
  }

  function planRemove(key, pageKeys) {
    var a = analyse(pageKeys);
    // Also take out anything that same Add pulled in with it (the page's own
    // product that went in as part of a bundle), so the cart goes back to how it was.
    var drop = [key].concat(pulled()[key] || []);
    var T = a.cartKeys.filter(function (k) { return !has(drop, k); });
    var pick = T.length ? cover(T, []) : { items: [] };
    if (!pick) return null;
    var d = diff(a, pick);
    d.bundle = null;
    pick.items.forEach(function (it) { if (it.b) d.bundle = it.b; });
    return d;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
    return uniq(ids);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function read() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { cart = c; cartAt = Date.now(); return c; });
  }

  function apply(p, source) {
    // No section HTML is requested here: the cart drawer re-renders itself
    // when it hears cart:update without sections, which keeps it open and
    // full height (morphing it from this response collapsed the open drawer).
    //
    // Speed: when none of the products being added is already in the cart,
    // the adds and removes go to Shopify as ONE save (/cart/update.js takes
    // variant ids to add and line keys to remove together) and its reply is
    // the whole cart, so no separate read is needed. Each save costs about a
    // second with the cart apps attached, so a bundle swap halves.
    var inCart = function (v) { return cart && cart.items.some(function (it) { return it.variant_id === v; }); };
    var oneSave = !p.add.some(inCart) && uniq(p.add).length === p.add.length;
    var chain;
    if (oneSave) {
      var all = {};
      p.remove.forEach(function (line) { all[line] = 0; });
      p.add.forEach(function (v) { all[v] = 1; });
      chain = post('/cart/update.js', { updates: all }).then(function (c) { cart = c; cartAt = Date.now(); return c; });
    } else {
      chain = Promise.resolve(null);
      if (p.add.length) {
        var body = { items: p.add.map(function (v) { return { id: v, quantity: 1 }; }) };
        chain = chain.then(function () { return post('/cart/add.js', body); });
      }
      if (p.remove.length) {
        var upd = {};
        p.remove.forEach(function (line) { upd[line] = 0; });
        chain = chain.then(function () { return post('/cart/update.js', { updates: upd }); });
      }
      chain = chain.then(function () { return read(); });
    }
    return chain.then(function (res) {
      return Promise.resolve(res).then(function (c) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: c, sourceId: source || 'nalia-routine', data: { source: source || 'nalia-routine', itemCount: c.item_count, deferDrawerOpen: true } }
        }));
        // The gift app adds or removes the free Dewy Duo a moment later.
        // If the cart changes after that, refresh the drawer once more.
        setTimeout(function () {
          read().then(function (c2) {
            if (c2.item_count !== c.item_count) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: c2, sourceId: 'nalia-refresh', data: { source: 'nalia-refresh', itemCount: c2.item_count, deferDrawerOpen: true } }
              }));
            }
          });
        }, 1500);
        return c;
      });
    });
  }

  // Plan from the cart in memory; if Shopify refuses (the cart changed
  // somewhere else meanwhile), read it again and try once more.
  function run(plan, ok, source) {
    return fresh().then(function () {
      var p = plan();
      if (!ok(p)) throw { description: '' };
      return apply(p, source).then(function () { return p; }, function (err) {
        return read().then(function () {
          var p2 = plan();
          if (!ok(p2)) throw err;
          return apply(p2, source).then(function () { return p2; });
        });
      });
    });
  }

  function add(key, pageKeys, source) {
    return run(function () { return planAdd(key, pageKeys); }, function (p) { return !!(p && p.add.length); }, source).then(function (p) {
      return Promise.resolve().then(function () {
        // Remove takes out only the step that was tapped; the page's own
        // product stays in, so nothing is recorded to undo with it.
        var h = pulled();
        delete h[key];
        savePulled(h);
        return p;
      });
    });
  }

  function remove(key, pageKeys, source) {
    return run(function () { return planRemove(key, pageKeys); }, function (p) { return !!(p && (p.add.length || p.remove.length)); }, source).then(function (p) {
      return Promise.resolve().then(function () {
        var h = pulled();
        delete h[key];
        savePulled(h);
        return p;
      });
    });
  }

  // Cart drawer: × on a product inside a bundle line takes out just that product.
  // Captured before the drawer's own click handling, so tapping × never
  // closes the drawer; the hold above keeps it open while the cart refreshes.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nalia-rm]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(8000);
    remove(btn.getAttribute('data-nalia-rm'), [], 'nalia-cart').then(function () {
      if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(5000);
    }).catch(function () {
      btn.classList.remove('is-busy');
    });
  }, true);

  window.NaliaBundles = {
    config: C,
    read: read,
    cart: function () { return cart; },
    analyse: analyse,
    planAdd: planAdd,
    planRemove: planRemove,
    canRemove: canRemove,
    add: add,
    remove: remove,
    keysFor: function (productId) { var m = byPid[productId]; return m ? m.keys.slice() : []; },
    bundleFor: function (productId) { var m = byPid[productId]; return m && m.bundle ? m.bundle : null; },
    nameOf: function (k) { return (C.names && C.names[k]) || k; }
  };
})();
